import React from 'react';
import { Tooltip } from 'antd';
import ReviewEditorAnchor from '../ReviewEditorAnchor';
import { useUserReviewEditor } from '../data/UserReviewEditorProvider';
import { Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import { useUser } from '../../../User/containers/UserDataStore';
import './muchLoveAnchor.css';

MuchLoveAnchor.propTypes = {
	rating: PropTypes.number,
	sku: PropTypes.string,
	onUpdate: PropTypes.func,
};

export default function MuchLoveAnchor({ rating, sku, onUpdate }) {
	const { editorController } = useUserReviewEditor();
	const { isAnonymous } = useUser();

	const clickedHeartStyle = 'icon-heart color-red clickable much-love-anchor';
	const unclickedHeartStyle = 'icon-heart-o clickable much-love-anchor';

	const handleSubmit = async () => {
		await editorController.save({
			fallbackOverallRating: 9,
			doSubmitSharingState: true,
		});
		await onUpdate();
	};

	const handleRemove = async () => {
		await editorController.remove();
		await onUpdate();
	};

	const getRatingHeart = rating => {
		let muchLove = rating > 8;
		return !rating
			? noRatingHeart()
			: muchLove
			? muchLoveRatingHeart()
			: ratingHeart();
	};

	const muchLoveRatingHeart = () => {
		return (
			<Popconfirm
				placement="bottomLeft"
				title="Are you sure you want to delete this review?"
				onConfirm={handleRemove}
				okText="Yes"
				cancelText="No">
				<div className={clickedHeartStyle} />
			</Popconfirm>
		);
	};

	const noRatingHeart = () => {
		return <div onClick={handleSubmit} className={unclickedHeartStyle} />;
	};

	const ratingHeart = () => {
		return (
			<ReviewEditorAnchor sku={sku} onUpdate={onUpdate}>
				<div
					className={
						rating === 8 ? clickedHeartStyle : unclickedHeartStyle
					}
				/>
			</ReviewEditorAnchor>
		);
	};

	return (
		<Tooltip title={<span style={{ fontSize: '11px' }}>Much Love!</span>}>
			{isAnonymous() ? (
				<div className={unclickedHeartStyle} />
			) : (
				getRatingHeart(rating)
			)}
		</Tooltip>
	);
}
